// $('.svg-content-viewfinder').css({
//     'width': $('.svg-wrapper-viewfinder').width() + 'px',
//     'height': $('.svg-wrapper-viewfinder').height() + 'px'
// });

// Slider News
$('.slider-news').bxSlider({
    slideWidth: 360,
    slideMargin: 30,
    minSlides: 1,
    maxSlides: 3,
    nextSelector: '#slider-next-home',
    prevSelector: '#slider-prev-home',
    nextText: '<i class="fal fa-chevron-right"></i>',
    prevText: '<i class="fal fa-chevron-left"></i>',
    pager: false,
    auto: true,
    pause: 6000
});

// Slider Guides
$(document).ready(function() {
    $('.slider-guides').bxSlider({
        slideWidth: 280,
        slideMargin: 10,
        minSlides: 1,
        maxSlides: 4,
        nextSelector: '#slider-next-home',
        prevSelector: '#slider-prev-home',
        nextText: '<i class="fal fa-chevron-right"></i>',
        prevText: '<i class="fal fa-chevron-left"></i>',
        pager: true,
        auto: true,
        pause: 6000
    });
});